import React from 'react';
import { Spinner } from 'react-bootstrap';
import SysProtocol from '../net/SysProtocol';

export default class PBIAnalysisPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Url: null,
    };

    console.log('create PBIAnalysis page');
  }

  componentDidMount() {
    //TODO: sotre id
    const path = this.props.location.pathname;
    let pages = path.split("/");
    let pageName = pages[pages.length - 1];
    SysProtocol.ins().reqGetPBIAnalysisUrl(0, pageName, (url) => {
      console.log('get url : '+url);
      this.setState({
        Url: url
      }, this.initViz);
    });
  }
  
  initViz() {  
    
  }

  render() { 
    if(this.state.Url === null){
      return (
        <div className="p-5 d-flex align-items-center flex-column">
          <Spinner animation="border" role="status" />
        </div>
      );
    }

    return (
      <iframe src={this.state.Url} width={"100%"} height={"100%"} frameBorder={0} />
    );
  }
}